import OfficialStores from '../../../../components/official-stores/official.stores.desktop';
import officialStores from './official-stores';

export default officialStores(OfficialStores);
